import { render } from "./CreateForm.vue?vue&type=template&id=1fdcd50a&ts=true"
import script from "./CreateForm.vue?vue&type=script&lang=ts"
export * from "./CreateForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__